import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import PrivateRoutes from './routes/PrivateRoutes';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import ErrorPage from './pages/ErrorPage';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './auth/msalConfig';
import ARDashboard from './pages/Ariba/ARDashboard';
import Reporting from './pages/Ariba/ARReporting/Reporting';
import ForecastCollabCPS from './pages/Ariba/CPS';
import SupplierManagement from './pages/Ariba/SupplierManagement';
import KPIMetricReports from './pages/Ariba/KPIMetrics/KPIMetricReports';
import AlertsPage from './pages/Ariba/Alerts/AlertsPage';
import AdminAnnouncements from './pages/Ariba/AdminAnnouncements/AdminAnnouncements';
import SupplierAnnouncements from './pages/Ariba/SupplierAnnouncements/SupplierAnnouncement';
import VideoPlayer from './pages/videoContent/VideoPlayer';
import AdminTraining from './pages/adminTraining/AdminTraining';
import POExceptionManagement from './pages/POExceptionManagement';
import { ExtractForecastFromSAP } from './pages/Ariba/ExtractForecastSAP/ExtractForecastFromSAP';
import ForecastReviewPeriodConfig from './pages/settingsConfig/ForecastReviewPeriodConfig';
import ForecastPublishExclusion from './pages/settingsConfig/ForecastPublishExclusion';
import TicketSummary from './components/MainContent/TicketSummary';
import SupplierAlertPage from './pages/Ariba/Alerts/SupplierAlertPage';
import ForecastHistoryPage from './pages/Ariba/ForecastHistory/ForecastHistoryPage';
import ForecastExtractionSchedulePage from './pages/ForecastExtractionSchedule/ForecastExtractionSchedulePage';
import AdminManageWhitelistDomain from './pages/Ariba/SupplierManagement/ApplicationAdmin/AdminManageWhitelistDomain';
import ExtractForcastPage from './pages/Ariba/ExtractForecastSAP/ExtractForcastPage';

const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

document.title = process.env.REACT_APP_PAGE_TITLE;

const observerError = "ResizeObserver loop completed with undelivered notifications.";
window.addEventListener("error", (e) => {
  if (e.message === observerError) {
    e.stopImmediatePropagation();
  }
});

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Provider store={store}>
        <App />
      </Provider>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: "dashboard",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ARDashboard />,
          },
        ],
      },
      {
        path: "forecastCollabPage",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ForecastCollabCPS />,
          },
        ],
      },
      {
        path: "poExceptionManagement",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <POExceptionManagement />,
          },
        ],
      },
      {
        path: "reports",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <Reporting />,
          },
        ],
      },
      {
        path: "admin-announcements",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <AdminAnnouncements />,
          },
        ],
      },
      {
        path: "kpimetrics",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <KPIMetricReports />,
          },
        ],
      },
      {
        path: "alerts",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <AlertsPage />,
          },
        ],
      },
      {
        path: "admin",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <SupplierManagement />,
          },
        ],
      },
      {
        path: "/admin/manage-users",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <SupplierManagement />,
          },
        ],
      },
      {
        path: "/admin/manage-reason-codes",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <SupplierManagement />,
          },
        ],
      },
      {
        path: "/admin/manage-domain-whitelisting",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <AdminManageWhitelistDomain/>,
          },
        ],
      },
      {
        path: "supplier-announcements",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <SupplierAnnouncements />,
          },
        ],
      },
      {
        path: "training",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <VideoPlayer />,
          },
        ],
      },
      {
        path: "admin-training",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <AdminTraining />,
          },
        ],
      },
      {
        path: "run-forecast-extraction",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ExtractForcastPage />,
          },
        ],
      },
      {
        path: "/settingsConfig",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ForecastReviewPeriodConfig />,
          },
        ],
      },
      {
        path: "/forecast-publish-exclusion",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ForecastPublishExclusion />,
          },
        ],
      },
      {
        path: "/ticketsummary",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <TicketSummary />,
          },
        ],
      },
      {
        path: "/supplieralerts",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <SupplierAlertPage />,
          },
        ],
      },
      {
        path: "/forecastHistoryPage",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ForecastHistoryPage />,
          },
        ],
      },
      {
        path: "/forecast-extraction-schedule",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ForecastExtractionSchedulePage />,
          },
        ],
      },
    ],
  },

]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <RouterProvider router={router} />
    </MsalProvider>
  </React.StrictMode>
);
reportWebVitals();